import * as React from 'react'
import styled from 'styled-components'

import { AttributeSection, FitSelector } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { useAccentColor } from '../../../../../../containers/AccentColorContainer'
import { trackEvent } from '../../../../../../lib/analytics'
import { EmbroiderySectionWrapper } from '../../../../../embroidery/EmbroiderySectionWrapper'

import { IProps } from './IProps'

// The backend APIs are not returning the display values with the correct casing
const SelectedFit = styled.span`
  text-transform: capitalize;
`

export const FitsSection: React.FC<IProps> = ({
  fitKeys,
  fitNames,
  hideTitle,
  onFitSelect,
  selectedFitKey,
  title,
  ...rest
}) => {
  const {
    pages: {
      product: { scrubPantsFitTitle },
    },
  } = useTranslation()
  const { accentColor } = useAccentColor()

  const sectionTitle = hideTitle ? undefined : title || scrubPantsFitTitle
  const selection = selectedFitKey ? fitNames?.get(selectedFitKey) ?? selectedFitKey : undefined

  return (
    <EmbroiderySectionWrapper {...rest} className='fit-section'>
      <AttributeSection
        title={sectionTitle}
        selection={<SelectedFit>{selection}</SelectedFit>}
        id='fits-section-title'
      >
        <div
          {...trackEvent({
            category: 'product details',
            action: 'snapshot',
            label: 'fit',
            value: selectedFitKey,
          })}
        >
          <FitSelector
            accentColor={accentColor}
            fits={fitKeys}
            fitNames={fitNames}
            onFitSelect={onFitSelect}
            data-testid='fits-picker'
            selected={selectedFitKey}
            disableMobileHorizontalSwipe
            {...trackEvent({ category: 'product details', action: 'select fit' })}
          />
        </div>
      </AttributeSection>
    </EmbroiderySectionWrapper>
  )
}
